import {
  Input,
  Inject,
  OnInit,
  Directive,
  HostListener,
} from 'ng-metadata/core';

@Directive({
  selector: '[gwPopup]',
})
export class PopupDirective {

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$element') private $element: ng.IWindowService,
    @Inject('$window') private $window: ng.IWindowService,
  ) {}

  @Input() width: number;
  @Input() height: number;

  @HostListener('click')
  clickOnHostElement() {
    const url = this.$element.attr('href') || '';
    this.width = this.width || 500;
    this.height = this.height || 500;

    const dualScreenLeft = this.$window.screenLeft !== undefined
      ? this.$window.screenLeft : this.$window.screenX;
    const dualScreenTop = this.$window.screenTop !== undefined
      ? this.$window.screenTop : this.$window.screenY;

    const width = this.$window.innerWidth ?
      this.$window.innerWidth :
        this.$window.document.documentElement.clientWidth ?
          this.$window.document.documentElement.clientWidth : this.$window.screen.width;

    const height = this.$window.innerHeight ?
      this.$window.innerHeight :
        this.$window.document.documentElement.clientHeight ?
          this.$window.document.documentElement.clientHeight : screen.height;

    const top = ((height / 2) - (this.height / 2)) + dualScreenTop;
    const left = ((width / 2) - (this.width / 2)) + dualScreenLeft;

    const options = [
      `top=${top}`,
      `left=${left}`,
      'scrollbars=no',
      `width=${this.width}`,
      `height=${this.height}`,
    ].join(',');

    // Open window
    const popup = this.$window.open(url, 'popup', options);

    // Puts focus on the new window
    if (this.$window.focus) {
      popup.focus();
    }

    return false;
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/popup.directive.ts